export const itemTypeOptions = [
  {label: '实物商品', value: 0},
  // {label: '虚拟商品', value: 60},
  // {label: '电子卡券', value: 61},
  // {label: '茶饮烘焙', value: 64},
]
export const deliverMethodsOptions = [
  {label: '快递发货', value: 'express'},
  {label: '同城配送', value: 'cityDelivery'},
  {label: '到店自提', value: 'selfPick'},
]